const selectors = {
  popupClose: '.js-popup-close',
  spinner: '.js-spinner',
  initCalculatorsBtn: '.js-init-calculators',
  calculatorsPopup: '.js-calculators-popup',
  calculatorOverlay: '.js-calculator-overlay',
  calculatorTabs: '[data-calculator-tabs]',
  calculatorBody: '[data-calculator-body]',
  calculatorSchemes: '[data-calculator-schemes]',
};

const calculatorsPopup = document.querySelector(selectors.calculatorsPopup);
const calculatorOverlay = document.querySelector(selectors.calculatorOverlay);
const spinner = document.querySelector(selectors.spinner);
const bnpBtn = document.querySelector(selectors.bnpBtn);
const bnpTable = document.getElementById('bnpSchemes');

const calculatorTabs = document.querySelector(selectors.calculatorTabs);
const calculatorSchemes = document.querySelector(selectors.calculatorSchemes);

let price = null;

const tbiMaturity = [];
const bnpMaturity = [];

//TBI SCHEME
const initTbiScheme = () => {
  return new Promise((resolve, reject) => {
    toggleSpinner(true);

    fetch(
      `https://apps.gloross.com/TBIShopifyWebhook/GetCalcForAllScheme?privateAppId=20&amount=${price}&categoryId=123`,
      {
        method: 'POST',
        mode: 'cors',
        headers: {
          accept: 'application/json',
        },
      }
    )
      .then((response) => response.json())
      .then((data) => {
        const messages = Object.entries(JSON.parse(data.message));

        messages.forEach((message) => {
          const values = message.pop();
          tbiMaturity.push(values.NumberInstallments);

          calculatorSchemes.innerHTML += `
            <div class="calculator-popup__scheme" data-maturity-scheme="${values.NumberInstallments}">
              <span class="calculator-popup__scheme__item calculator-popup__scheme__item--price">
                <span class="is-hidden-desktop-only">
                  Месечна вноска:
                </span>

                ${values.MonthlyPayment} лв.
              </span>

              <span class="calculator-popup__scheme__item">
                <span class="is-hidden-desktop-only">
                  Обща сума:
                </span>

                ${values.TotalAmountDue} лв.
              </span>

              <span class="calculator-popup__scheme__item">
                <span class="is-hidden-desktop-only">
                  ГПР:
                </span>

                ${values.Gpr}%
              </span>

              <span class="calculator-popup__scheme__item">
                <span class="is-hidden-desktop-only">
                  Лихва:
                </span>

                ${values.Glp}%
              </span>

              <span class="calculator-popup__scheme__item calculator-popup__scheme__item--logo">
                <img src="${tbiLogo}">
              </span>
            </div>
          `;
        });

        resolve(); // Resolve the promise here after the data processing is done
      })
      .catch((error) => {
        toggleSpinner(false);
        handlePopupClose();
        console.error('Error:', error);
        reject(error); // Reject the promise if there's an error
      });
  });
};

const initBnpScheme = () => {
  return new Promise((resolve, reject) => {
    toggleSpinner(true);

    fetch(`https://apps.gloross.com/BNP/Variants?privateAppId=16&totalPrice=${price}`, {
      method: 'POST',
      mode: 'cors',
      headers: {
        accept: 'application/json',
        'Access-Control-Allow-Origin': '*',
      },
    })
      .then((response) => response.json())
      .then((data) => {
        const {PricingVariant} = JSON.parse(data);

        if (!PricingVariant.length) {
          resolve(); // Resolve the promise here if there's no data
          return;
        }

        // add variant.Maturity to bnpMaturity
        PricingVariant.forEach((variant) => {
          bnpMaturity.push(variant.Maturity);

          calculatorSchemes.innerHTML += `
            <div class="calculator-popup__scheme" data-maturity-scheme="${variant.Maturity}">
              <span class="calculator-popup__scheme__item calculator-popup__scheme__item--price">
                <span class="is-hidden-desktop-only">
                  Месечна вноска:
                </span>

                ${variant.InstallmentAmount} лв.
              </span>

              <span class="calculator-popup__scheme__item">
                <span class="is-hidden-desktop-only">
                  Обща сума:
                </span>

                ${variant.TotalRepaymentAmount} лв.
              </span>

              <span class="calculator-popup__scheme__item">
                <span class="is-hidden-desktop-only">
                  ГПР:
                </span>

                ${variant.APR}%
              </span>

              <span class="calculator-popup__scheme__item">
                <span class="is-hidden-desktop-only">
                  Лихва:
                </span>

                ${variant.NIR}%
              </span>

              <span class="calculator-popup__scheme__item calculator-popup__scheme__item--logo">
                <img src="${bnpLogo}">
              </span>
            </div>
          `;
        });

        resolve(); // Resolve the promise here after the data processing is done
      })
      .catch((error) => {
        toggleSpinner(false);
        handlePopupClose();
        console.error('Error:', error);
        reject(error); // Reject the promise if there's an error
      });
  });
};

document.querySelector(selectors.initCalculatorsBtn)?.addEventListener('click', (e) => {
  e.target.setAttribute('disabled', true);
  price = e.target.dataset.price;
  price = price.slice(0, -2) + '.' + price.slice(-2);

  // Use Promise.all to wait for both Promises to resolve
  // Promise.all([initTbiScheme(), initBnpScheme()]).then(() => {
  Promise.all([initTbiScheme()]).then(() => {
    let mergedArray = [...new Set([...tbiMaturity, ...bnpMaturity])];

    calculatorTabs.innerHTML = `
      ${mergedArray
        .sort((a, b) => a - b)
        .map((maturity) => {
          return `<button type="button" class="calculator-popup__tab" data-maturity="${maturity}">${maturity} месеца</button>`;
        })
        .join('')}
    `;

    //hide spinner
    toggleSpinner(false);
    //show popup
    calculatorsPopup.classList.add('is-visible');
    calculatorsPopup.previousElementSibling.classList.add('is-visible');

    //add event listener to tabs
    const calculatorTabsBtns = document.querySelectorAll(`${selectors.calculatorTabs} button`);
    calculatorTabsBtns.forEach((btn) => {
      btn.addEventListener('click', (e) => {
        const maturity = e.target.dataset.maturity;

        calculatorTabsBtns.forEach((btn) => {
          btn.classList.remove('is-active');
        });

        e.target.classList.add('is-active');
        const schemes = document.querySelectorAll(`${selectors.calculatorSchemes} div`);
        schemes.forEach((scheme) => {
          if (scheme.dataset.maturityScheme === maturity) {
            scheme.classList.add('is-selected');
          } else {
            scheme.classList.remove('is-selected');
          }
        });
      });
    });

    document.querySelector(selectors.initCalculatorsBtn).removeAttribute('disabled');
  });
});

//TOGGLE SPINNER
const toggleSpinner = (isVisible) => {
  spinner.classList[isVisible ? 'add' : 'remove']('is-visible');
};

//CLOSE POPUP
const handlePopupClose = () => {
  calculatorsPopup.classList.remove('is-visible');
  calculatorsPopup.previousElementSibling.classList.remove('is-visible');

  //empty schemes
  tbiMaturity.length = 0;
  bnpMaturity.length = 0;
  calculatorSchemes.innerHTML = '';
  document.querySelector(selectors.initCalculatorsBtn).removeAttribute('disabled');
};

document.querySelector(selectors.popupClose).addEventListener('click', handlePopupClose);
document.querySelector(selectors.calculatorOverlay).addEventListener('click', handlePopupClose);
